import React from 'react';
import { getIntl } from '../../../../../utils/intl';
import { ContentStack } from '../../../../v2BaseComponents/Stack';
import Text from '../../../../v2BaseComponents/Text';
import { PromptActions } from '../../../../v2BaseComponents/Prompt';
import { ActivityIndicator, View } from 'react-native';

const intl = getIntl('fastenDeleteConfirmationPromptContents', {
    confirmationMessage:
        'Are you sure you want to disconnect from {connectionName}? This will remove the connection from your profile.',
    disconnect: 'Disconnect',
    disconnecting: 'Disconnecting...',
    cancel: 'Cancel',
});

export type DeleteConfirmationPromptContentsOwnProps = {
    connectionName: string;
    onClose: () => void;
    onDisconnect: () => void;
    isDisconnecting?: boolean;
};

export type DeleteConfirmationPromptContentsProps = DeleteConfirmationPromptContentsOwnProps;

const DeleteConfirmationPromptContents: React.FC<DeleteConfirmationPromptContentsProps> = ({
    connectionName,
    onClose,
    onDisconnect,
    isDisconnecting,
}) => {
    if (isDisconnecting) {
        return (
            <ContentStack>
                <View
                    style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        paddingVertical: 32,
                        width: '100%',
                    }}
                >
                    <ActivityIndicator size="large" color="#4F46E5" />
                    <Text variant="body-1" style={{ marginTop: 16 }} alignText="center">
                        {intl('disconnecting')}
                    </Text>
                </View>
            </ContentStack>
        );
    }

    return (
        <ContentStack>
            <Text variant="body-1">{intl('confirmationMessage', { connectionName })}</Text>
            <PromptActions
                actions={[
                    {
                        title: intl('disconnect'),
                        variant: 'alert',
                        icon: 'Trash2',
                        onPress: onDisconnect,
                    },
                    {
                        title: intl('cancel'),
                        onPress: onClose,
                        variant: 'secondary',
                        icon: 'X',
                    },
                ]}
            />
        </ContentStack>
    );
};

export default React.memo(DeleteConfirmationPromptContents);
